const ALERTA_ERROR = {
  mensaje: 'Ha ocurrido un error. Intente más tarde.',
  tiempo: 5000,
  visible: true,
  noVisible: false,
}

const ALERTA_EXITO = {
  mensaje: 'Operación exitosa',
  tiempo: 5000,
  visible: true,
  noVisible: false,
}

const ID_PRODUCTO_CREDITO_ACTIVACASH = 245

const ID_PRODUCTO_CREDITO_ENLAZAMAS = 246

const ID_PRODUCTO_CREDITO_SP = 266

const ID_PRODUCTO_CREDITO_SPLUS = 309

const ID_PROCESO_CREDITO_DIGITAL_CONSUMO = 1

// const ID_PROCESO_CREDITO_DIGITAL_NOMINA = 2

const KEYS_VALIDAS_OTP = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']

const TERMINOS_CONDICIONES_DOC_URL = 'docs/Terminos-y-condiciones.pdf'
const AVISO_PRIVACIDAD_DOC_URL = 'docs/Aviso de privacidad 2022.pdf'
const CONTRATO_DOC_URL = 'docs/CONTRATO_SIMPLE_MULTIPLE.pdf'

const MENSAJE_ERROR_500 = 'Ha ocurrido un error. Intente más tarde.'
const ALERTA_TIEMPO_DEFAULT = 5000
const ALERTA_VISIBLE = true
const ALERTA_NO_VISIBLE = false

const ID_PRODUCTO_DOCUMENTO_COMPROBANTE_DOMICILIO = 4

const convertirArchivoABase64 = (archivo) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(archivo)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

const comprimirImagen = (archivo, orientacion, callback) => {
  let ancho_maximo = 1280
  let altura_maxima = 720
  const mime_type = 'image/png'
  const calidad = 0.8

  switch (orientacion) {
    case 'landscape':
      ancho_maximo = 1280
      altura_maxima = 720
      break
    case 'portrait':
      ancho_maximo = 720
      altura_maxima = 1280
      break
    case 'even':
      ancho_maximo = 720
      altura_maxima = 720
      break
    default:
      ancho_maximo = 1280
      altura_maxima = 720
  }

  const blobURL = URL.createObjectURL(archivo)
  const img = new Image()
  img.src = blobURL
  img.onerror = function () {
    URL.revokeObjectURL(this.src)
    console.error('Error al obtener imagen')
  }
  img.onload = function () {
    URL.revokeObjectURL(this.src)
    const [nuevoAncho, nuevaAltura] = calculateSize(
      img,
      ancho_maximo,
      altura_maxima
    )
    const canvas = document.createElement('canvas')
    canvas.width = nuevoAncho
    canvas.height = nuevaAltura
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, nuevoAncho, nuevaAltura)
    canvas.toBlob(
      (blob) => {
        callback(blob)
      },
      mime_type,
      calidad
    )
  }
  function calculateSize(img, maxWidth, maxHeight) {
    let width = img.width
    let height = img.height

    if (width > height) {
      if (width > maxWidth) {
        height = Math.round((height * maxWidth) / width)
        width = maxWidth
      }
    } else {
      if (height > maxHeight) {
        width = Math.round((width * maxHeight) / height)
        height = maxHeight
      }
    }
    return [width, height]
  }
}

const detectarOrientacionImagen = (archivo, callback) => {
  let orientacion
  const blobURL = URL.createObjectURL(archivo)
  const img = new Image()
  img.src = blobURL
  img.onload = function () {
    if (img.naturalWidth > img.naturalHeight) {
      orientacion = 'landscape'
    } else if (img.naturalWidth < img.naturalHeight) {
      orientacion = 'portrait'
    } else {
      orientacion = 'even'
    }
    callback(orientacion)
  }
}

const capitalizeFirstLetter = function (string) {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1)
  return ''
}

//plazos validos para socio plus digital
const plazosValidos = function (monto, plazos, rangos) {
  const result = plazos.filter((plazo) => {
    return rangos.some(
      (rango) =>
        plazo.val >= rango.plazo_min &&
        plazo.val <= rango.plazo_max &&
        monto >= rango.monto_min &&
        monto <= rango.monto_max
    )
  })

  return result
}

export {
  ALERTA_ERROR,
  ALERTA_EXITO,
  KEYS_VALIDAS_OTP,
  MENSAJE_ERROR_500,
  ALERTA_TIEMPO_DEFAULT,
  ALERTA_VISIBLE,
  ALERTA_NO_VISIBLE,
  ID_PRODUCTO_CREDITO_ACTIVACASH,
  ID_PRODUCTO_CREDITO_ENLAZAMAS,
  ID_PRODUCTO_CREDITO_SP,
  ID_PRODUCTO_CREDITO_SPLUS,
  ID_PROCESO_CREDITO_DIGITAL_CONSUMO,
  TERMINOS_CONDICIONES_DOC_URL,
  AVISO_PRIVACIDAD_DOC_URL,
  CONTRATO_DOC_URL,
  ID_PRODUCTO_DOCUMENTO_COMPROBANTE_DOMICILIO,
  convertirArchivoABase64,
  comprimirImagen,
  detectarOrientacionImagen,
  capitalizeFirstLetter,
  plazosValidos,
}
